import React from 'react';
import { styled } from '@mui/material';
import { Add } from '@mui/icons-material';
import { Colors } from 'library';
import { BaseButton } from './BaseButton';

type DashedAddButtonVariant = 'inline' | 'card';

interface DashedAddButtonProps {
    children: React.ReactNode;
    onClick: () => void;
    size?: 'sm' | 'md';
    variant?: DashedAddButtonVariant;
    icon?: React.ReactNode;
}

export function DashedAddButton({ children, onClick, size = 'md', variant = 'inline', icon }: DashedAddButtonProps) {
    const iconSize = variant === 'card' ? 28 : size === 'sm' ? 16 : 18;
    return (
        <Button size={size} $variant={variant} onClick={onClick}>
            {icon ?? <Add sx={{ fontSize: iconSize, color: Colors.textSecondary }} />}
            {children}
        </Button>
    );
}

const Button = styled(BaseButton, { shouldForwardProp: (p) => p !== '$variant' })<{
    size: 'sm' | 'md';
    $variant: DashedAddButtonVariant;
}>(({ size, $variant }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    padding: size === 'sm' ? '6px 12px' : '14px 16px',
    border: `1px dashed ${Colors.border}`,
    borderRadius: size === 'sm' ? 8 : 10,
    fontSize: size === 'sm' ? 13 : 14,
    fontWeight: 500,
    color: Colors.textSecondary,
    backgroundColor: Colors.white,
    alignSelf: 'flex-start',
    '&:hover': {
        borderColor: Colors.textSecondary,
        backgroundColor: Colors.surface,
    },
    ...($variant === 'card' && {
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 12,
        padding: 32,
        borderRadius: 12,
        fontSize: 16,
        fontWeight: 600,
        alignSelf: 'stretch',
        width: '100%',
        height: '100%',
    }),
}));
